module.exports = __webpack_public_path__ + "static/lato-v14-latin-300-54d3cfe0cec734925a21cebfe378a12e.svg";